import { useScheduleDimension } from "@/hooks/useScheduleDimension";
import { LABEL_WIDTH_DIMENSION } from "@/lib/scheduleRowHeights";

export interface ScheduleLabelWidth {
  labelWidth: number;
  setLabelWidth: (width: number) => void;
  resetLabelWidth: () => void;
}

/**
 * Adjustable width for the schedule's label column (stage / crew names),
 * persisted per briefing AND per view (`scope`). Scoping keeps the creator's
 * narrower column from silently narrowing the read-only timeline (they have
 * different defaults). Falls back to the view's own default until the
 * producer adjusts it.
 */
export function useScheduleLabelWidth(
  briefingId: string,
  scope: string,
  defaultWidth: number,
): ScheduleLabelWidth {
  const { value, setValue, reset } = useScheduleDimension(
    LABEL_WIDTH_DIMENSION,
    briefingId,
    scope,
    defaultWidth,
  );
  return { labelWidth: value, setLabelWidth: setValue, resetLabelWidth: reset };
}
